<script>
import { mapActions } from 'vuex';

export default {
  props: {
    action: {
      type: String,
      default: '',
    },
    dealerId: {
      type: String,
      default: null,
    },
    popupName: {
      type: String,
      default: '',
    },
    popupTitle: {
      type: String,
      default: '',
    },
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      addPopupData: 'Popups/addPopupData',
      addTitlePopup: 'Popups/addTitlePopup',
    }),

    popupOpen() {
      if (this.popupName) {
        this.togglePopup(this.popupName);
        this.addTitlePopup(this.popupTitle);
        this.addPopupData({
          dealerId: this.dealerId,
          action: this.action,
        });
      }
    },
  },
};
</script>

<template>
  <button @click="popupOpen()">
    <slot></slot>
  </button>
</template>

<style></style>
